import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import { CMS } from '../core/config'
import {EMITS as MENU_EMITS} from './Menu'


export const EMITS = {
    SELECTED: 'selected'
}

export default class Rooms extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            menu: null,
            roomSlider: null
        }

        this.roomSlider = null
        this.menu = null

        this.links = []

        this.index = null
        this.initializedWithHash = false
    }

    prepare() {
        if (CMS) {
            return
        }
        
        this.menu = Component.getFromElement(this.ref.menu)
        this.menu.on(MENU_EMITS.LINK_CLICKED, this.handleLinkClick)
        
        this.roomSlider = Component.getFromElement(this.ref.roomSlider)
        
        const index = this.getInitialIndex()

        setTimeout(() => {
            this.select(index)

            if (this.initializedWithHash) {
                scrollToElement(this.element)
            }
        }, 0);
    }

    handleLinkClick = data => {
        const index = data.index

        this.select(index)
    }

    getInitialIndex() {
        const url = window.location.href
        const anchor = url.substring(url.indexOf("#"))
        const links = this.menu.getLinks()

        let index = links.findIndex(link => link.hash === anchor)

        if (!~index) {
            index = this.menu.getActiveLinkIndex()
        } else {
            this.initializedWithHash = true
        }

        if (index < 0) {
            index = 0
        }

        return index
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.roomSlider.select(index)
        this.menu.select(index)
        
        this.index = index
        
        this.emit(EMITS.SELECTED, {
            index
        })
    }
}